import React from "react";
import Banner1 from "../../../assets/Images/banner1.png";
import { Stack, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import "../../../App.css";

const MainBanner = () => {
  if (isMobile) {
    return (
      <div
        style={{
          width: "100%",
          height: "300px",
          backgroundImage: `url(${Banner1})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          style={{
            //   width: "90%",
            //  margin: "auto",
            marginLeft: "5%",
            height: "100%",
          }}
        >
          <div style={{ width: "100%" }}>
            <Typography
              variant="h3"
              component="h1"
              color="white"
              style={{
                fontWeight: "600",
                fontSize: "16px",
                lineHeight: "22px",
                textAlign: "center",
              }}
            >
              Find a local and reliable handyman in few clicks!
            </Typography>
            <Typography
              variant="subtitle1"
              color="black"
              style={{ textAlign: "center", color: "white" }}
            >
              Post your request by filling simple requirement and get quotes
              from experts within few minutes.
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItem="center"
              justifyContent="center"
              className="mt-6"
            >
              <Link to="/create-request">
                <Button
                  variant="contained"
                  className="primary-button"
                  size="small"
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                    width: "150px",
                    paddingTop: "5px",
                    paddingBottom: "5px",
                    textAlign: "center",
                  }}
                >
                  Post Request
                </Button>
              </Link>
              <Link to="/choose-flow" state={{ flow: "register" }}>
                <Button
                  variant="outlined"
                  size="small"
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "white",
                    borderColor: "white",
                    width: "150px",
                  }}
                >
                  Become Partner
                </Button>
              </Link>
            </Stack>
          </div>
        </Stack>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "400px",
          backgroundImage: `url(${Banner1})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          style={{ width: "90%", margin: "auto" }}
        >
          <div
            style={{
              width: "50%",
              height: "400px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h3"
              component="h1"
              color="white"
              style={{
                fontWeight: "700",
                fontSize: "48px",
                lineHeight: "56px",
                marginBottom: "24px",
              }}
            >
              Find a local and reliable handyman in few clicks!
            </Typography>
            <Typography
              variant="subtitle1"
              color="white"
              style={{
                marginBottom: "32px",
              }}
            >
              Post your request by filling simple requirement and get quotes{" "}
              <br /> from experts within few minutes.
            </Typography>
            <Stack
              direction="row"
              spacing={3}
              alignItem="center"
              className="mt-6"
            >
              <Link to="/create-request">
                <Button
                  variant="contained"
                  className="primary-button"
                  size="small"
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                    textAlign: "center",
                    textTransform: "capitalize",
                    padding: "12px 24px",
                    borderRadius: "6px",
                  }}
                >
                  Post Request
                </Button>
              </Link>
              <Link to="/choose-flow" state={{ flow: "register" }}>
                <Button
                  variant="outlined"
                  size="small"
                  style={{
                    textTransform: "capitalize",
                    fontWeight: "500",
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: "white",
                    borderColor: "white",
                    textTransform: "capitalize",
                    padding: "10px 24px",
                    borderRadius: "6px",
                  }}
                >
                  Become Partner
                </Button>
              </Link>
            </Stack>
          </div>
        </Stack>
      </div>
    );
  }
};

export default MainBanner;
